import React, { Component } from "react";
import { ErrorNotification, MnemoLoading, Title } from "components/misc";
import { MCheckbox, MSelect } from "components/forms";
import { Button, Row, Col } from "design-react-kit";
import { lessonSectionService, stringHelper } from "libs";

export class LessonScheduleProcessTFAIndire extends Component {
  state = {
    is48: false,
    loading: false,
    loadingError: "",
    courseCode: "",
    academicYear: 0,
    students: [],
    prediction: false,
  };

  PAYLOAD_YEAR = {
    options: [
      { label: "SELEZIONA UN ANNO ACCADEMICO", value: 0 },
      { label: "2024/2025", value: 2024 },
      { label: "2025/2026", value: 2025 },
    ],
  };

  COURSECODES_2024 = [
    { label: "SELEZIONA UN CORSO", value: "" },
    { label: "SASUMESTERO77INF_36", value: "SASUMESTERO77INF_36" },
    { label: "SASUMESTERO77INF_48", value: "SASUMESTERO77INF_48" },
    { label: "SASUMESTERO77SEC1_36", value: "SASUMESTERO77SEC1_36" },
    { label: "SASUMESTERO77SEC1_48", value: "SASUMESTERO77SEC1_48" },
    { label: "SASUMESTERO77SEC2_36", value: "SASUMESTERO77SEC2_36" },
    { label: "SASUMESTERO77SEC2_48", value: "SASUMESTERO77SEC2_48" },
    { label: "SASUMTRIENNALISTI75PRI", value: "SASUMTRIENNALISTI75PRI" },
    { label: "SASUMTRIENNALISTI75SEC1", value: "SASUMTRIENNALISTI75SEC1" },
    { label: "SASUMTRIENNALISTI75SEC2", value: "SASUMTRIENNALISTI75SEC2" },
  ];

  COURSECODES_2025 = [
    { label: "SELEZIONA UN CORSO", value: "" },
    { label: "SASUMESTERO77INF_36_25", value: "SASUMESTERO77INF_36_25" },
    { label: "SASUMESTERO77INF_48_25", value: "SASUMESTERO77INF_48_25" },
    { label: "SASUMESTERO77SEC1_36_25", value: "SASUMESTERO77SEC1_36_25" },
    { label: "SASUMESTERO77SEC1_48_25", value: "SASUMESTERO77SEC1_48_25" },
    { label: "SASUMESTERO77SEC2_36_25", value: "SASUMESTERO77SEC2_36_25" },
    { label: "SASUMESTERO77SEC2_48_25", value: "SASUMESTERO77SEC2_48_25" },
    { label: "SASUMTRIENNALISTI75PRI_25", value: "SASUMTRIENNALISTI75PRI_25" },
    { label: "SASUMTRIENNALISTI75SEC1_25", value: "SASUMTRIENNALISTI75SEC1_25" },
    { label: "SASUMTRIENNALISTI75SEC2_25", value: "SASUMTRIENNALISTI75SEC2_25" },
  ];


  PAYLOAD_COURSECODE = {
    2024: {
      options: this.COURSECODES_2024,
    },
    2025: {
      options: this.COURSECODES_2025,
    },
  };

  setAcademicYear = (_, value) => {
    const courseCode = "";
    this.setState({ academicYear: value, courseCode });
  };

  setCourseCode = (_, value) => {
    this.setState({ courseCode: value, is48: value.includes("_48") });
  };

  setCity = (_, value) => {
    this.setState({ city: value });
  };

  setPrediction = (_, checked) => {
    this.setState({ prediction: checked });
  };

  loadStudents = () => {

    this.setState({ loading: true, loadingError: "" });
    const { courseCode, academicYear, prediction } = this.state;

    if (courseCode === "") {
      ErrorNotification.render("Devi specificare un corso per poter procedere");
      this.setState({ loading: false });
    } else {
      lessonSectionService
        .listAnalyticsStudentsTFAIndire(academicYear, courseCode, prediction)
        .then(({ data }) => {
          this.setState({ students: data.payload.students, loading: false });
        })
        .catch((error) => {
          console.error("Error ", error);
          ErrorNotification.render("Errore  server");
          this.setState({ loading: false, loadingError: error });
        });
    }
  };

  analyzeStudents = (e) => {
    //for the second click exit
    e.preventDefault();
    if (e.detail > 1) {
      return;
    }

    this.setState({ loading: true, loadingError: "" });
    const { students, courseCode, academicYear } = this.state;

    if (students.length === 0) {
      ErrorNotification.render("Nessuno studente da analizzare");
      this.setState({ loading: false });
    } else {
      if (courseCode.length === 0 || academicYear === 0) {
        ErrorNotification.render("Dati inconsistenti. Ricarica l'elenco degli studenti tramite il pulsante 'Elenco studenti'");
        this.setState({ loading: false });
      } else {
        lessonSectionService
          .analizeAnalyticsStudentsTFAIndire(academicYear, courseCode)
          .then(({ data }) => {
            this.loadStudents();
            this.setState({ loading: false });
          })
          .catch((error) => {
            console.error("Error ", error);
            ErrorNotification.render("Errore  server");
            this.setState({ loading: false, loadingError: error });
          });
      }
    }
  };

  exportStudents = () => {
    const { students, is48 } = this.state;
    if (students.length === 0) {
      ErrorNotification.render("Nessuno studente da analizzare");
      this.setState({ loading: false });
    } else {
      let str = is48
        ? "CODICE REGISTRAZIONE;COGNOME;NOME;EMAIL;TELEFONO;CODICE CORSO;MINUTI COLLEGAMENTO;MINUTI TOTALI 48 ORE;PERCENTUALE ATTUALE;LIMITE NON RAGGIUNTO;PERCENTUALE STIMATA;TIROCINIO DIRETTO\r\n"
        : "CODICE REGISTRAZIONE;COGNOME;NOME;EMAIL;TELEFONO;CODICE CORSO;MINUTI COLLEGAMENTO;MINUTI TOTALI;PERCENTUALE ATTUALE;LIMITE NON RAGGIUNTO;PERCENTUALE STIMATA;\r\n";

      for (let i = 0; i < students.length; i++) {
        const student = students[i];

        const percent = stringHelper.formatPercentage(student.percent);
        const limite = student.percent < 0.9 ? "LIMITE NON RAGGIUNTO" : "";
        const estimated = student.estimatedPercentage ? stringHelper.formatPercentage(student.estimatedPercentage) : "";
        let addRow = `${student.registrationCode};${student.surname};${student.name};${student.email};${student.mobile};${student.courseCode};${student.minutes};${student.totalMinutes};${percent};${limite};${estimated}`;
        if (is48) {
          const atd = student.atd ? student.atd : "NON SVOLTO";
          addRow += `;${atd}`;
        }
        str += addRow + "\r\n";
      }

      // calcolo il nome della edizione selezionata

      let downloadLink = document.createElement("a");
      downloadLink.href = "data:text/csv;charset=utf-8," + encodeURIComponent(str);
      downloadLink.download = "corsisti_frequenza_" + this.state.academicYear + "_" + this.state.courseCode + ".csv";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  };

  render() {
    const { loading, students, academicYear, is48, courseCode } = this.state;

    return (
      <>
        {loading && <MnemoLoading />}
        <section className="m-4">
          <Title>Analisi frequenza corsi TFA Indire</Title>
          <Row>
            <Col md={12}>
              <MSelect onChange={this.setAcademicYear} id="academicYear" payload={this.PAYLOAD_YEAR}></MSelect>
            </Col>
          </Row>
          {academicYear > 0 && (
            <>
              <Row>
                <Col md={6}>
                  <MSelect
                    key={academicYear}
                    onChange={this.setCourseCode}
                    id="courseCode"
                    payload={this.PAYLOAD_COURSECODE[academicYear]}
                    value={courseCode}
                  ></MSelect>
                </Col>
                <Col md={6}>
                  <MCheckbox
                    id="prediction"
                    label="Calcolare la previsione di frequenza<br/><span className='text-danger'><b>ATTENZIONE L'OPERAZIONE POTREBBE SOVRACCARICARE IL SERVER E RALLENTARE LA PIATTAFORMA</b></span>"
                    checked={this.state.prediction}
                    onChange={this.setPrediction}
                  />
                </Col>
              </Row>
            </>
          )}
          <Button
            color="primary bg-dark"
            onClick={() => {
              this.loadStudents();
            }}
          >
            <span className="d-button-label">Elenco studenti</span>
          </Button>
          <Button
            className="ml-2"
            color="primary"
            outline
            onClick={(e) => {
              this.analyzeStudents(e);
            }}
          >
            <span className="d-button-label">Calcola tempo presenza</span>
          </Button>
          <Button
            className="ml-2"
            color="primary"
            outline
            onClick={() => {
              this.exportStudents();
            }}
          >
            <span className="d-button-label">Esporta</span>
          </Button>
          <hr />
          {students.length > 0 && (
            <>
              <h5>Studenti trovati {students.length}</h5>
              <table className="MTable table  table-striped table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Codice registrazione</th>
                    <th>Cognome</th>
                    <th>Nome</th>
                    <th>Email</th>
                    <th>Telefono</th>
                    <th>Minuti (ore) collegamento</th>
                    <th>Frequenza di collegamento</th>
                    <th>Frequenza di collegamento stimata (*)</th>
                    {is48 && <th>Tirocinio Diretto</th>}
                  </tr>
                </thead>
                <tbody>
                  {students.map((student, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{student.registrationCode}</td>
                        <td>{student.surname}</td>
                        <td>{student.name}</td>
                        <td>{student.email}</td>
                        <td>{student.mobile}</td>
                        <td>
                          {student.minutes} su {student.totalMinutes} <br />({stringHelper.formatNumber(student.minutes / 60)} su{" "}
                          {stringHelper.formatNumber(student.totalMinutes / 60)})
                        </td>
                        <td>
                          {stringHelper.formatPercentage(student.percent)}{" "}
                          {student.percent < 0.9 && (
                            <>
                              <br />
                              <span className="text-red">LIMITE NON RAGGIUNTO</span>
                            </>
                          )}
                        </td>
                        <td>{student.estimatedPercentage && <>{stringHelper.formatPercentage(student.estimatedPercentage)}</>}</td>
                        {is48 && (
                          <td>
                            {student.atd ? (
                              <>{student.atd}</>
                            ) : (
                              <>
                                {" "}
                                <span className="text-red">NON SVOLTO</span>
                              </>
                            )}
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </>
          )}
        </section>
      </>
    );
  }
}
